<template>
  <main id="main">
  <!-- Header -->
  <div class="container py-4 py-lg-4">
    <div class = 'col-md-12'>
        <div class="row" v-for='event in events' :key="event.title">
              <event-card v-bind="event"></event-card>
        </div>
    </div>
  </div>
</main>
</template>

<style type="text/css">

</style>

<script>
import AirtableService from '@/services/AirtableService'
import EventCard from '@/components/EventCard'
import craftCourseThumb from '@/assets/images/teaser.jpg'
import coDesignThumb from '@/assets/images/teaser_bof26.png'
import residency22Thumb from '@/assets/images/residency_v1.png'
import residency23Thumb from '@/assets/images/ceramics_2023.png'
// import json from '@/assets/data/projects.json'

export default {
  name: 'events',
  components: {
    EventCard
  },

  data () {
    return {
      airtableResponse: []
    }
  },

  mounted: function () {
    const self = this
    async function getEvents () {
      try {
        const response = await AirtableService.getEvents()
        self.airtableResponse = response.data.records
      } catch (err) {
        console.log(err)
      }
    }
    getEvents()
  },

  computed: {
    events () {
      const self = this
      const events = []

      const getSortTimestamp = function (value) {
        if (!value) return 0
        const rawValue = String(value).trim()

        const parsed = Date.parse(rawValue)
        if (!Number.isNaN(parsed)) {
          return parsed
        }

        const monthYearMatch = rawValue.match(/(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)[a-z]*[^0-9]*(\d{4})/i)
        if (monthYearMatch) {
          const monthYearParsed = Date.parse(monthYearMatch[1] + ' 1, ' + monthYearMatch[2])
          if (!Number.isNaN(monthYearParsed)) {
            return monthYearParsed
          }
        }

        const yearMatch = rawValue.match(/(19|20)\d{2}/)
        if (yearMatch) {
          return new Date(Number(yearMatch[0]), 0, 1).getTime()
        }

        return 0
      }

      const featuredEvents = [
        {
          title: 'Computational Craft Course',
          snippet: 'Computational Fabrication Methods for Craft Production',
          startDate: 'SIGGRAPH Courses 2025',
          sortDate: '2025-08-10',
          thumb: craftCourseThumb,
          linkTo: '/craftcourse'
        },
        {
          title: 'Towards co-design in computer graphics',
          snippet: 'Building collaborative relationships between researchers and artists',
          startDate: 'SIGGRAPH BOF July 20, 2026',
          sortDate: '2026-07-20',
          thumb: coDesignThumb,
          linkTo: '/towards-codesign'
        },
        {
          title: 'Experimental Clay Residency 2022',
          snippet: 'Summer residency exploring integrations of ceramic craft and new technology',
          startDate: 'June - September 2022',
          sortDate: '2022-06-20',
          thumb: residency22Thumb,
          linkTo: '/residency22'
        },
        {
          title: 'Experimental Clay Residency 2023',
          snippet: 'Second-year experimental ceramic craft residency with the ECL',
          startDate: 'June - September 2023',
          sortDate: '2023-06-19',
          thumb: residency23Thumb,
          linkTo: '/residency23'
        }
      ]

      events.push(...featuredEvents)

      for (var i = 0; i < self.airtableResponse.length; i++) {
        if (self.airtableResponse[i].fields.published) {
          const project = {
            title: self.airtableResponse[i].fields.title,
            snippet: self.airtableResponse[i].fields.snippet,
            authors: self.airtableResponse[i].fields.collaborators,
            slug: self.airtableResponse[i].fields.slug,
            startDate: self.airtableResponse[i].fields.startDate,
            sortDate: self.airtableResponse[i].fields.startDate,
            thumb: self.airtableResponse[i].fields.media[0].url
          }
          events.push(project)
        }
      }
      return events.sort(function (a, b) {
        const bTime = getSortTimestamp(b.sortDate || b.startDate)
        const aTime = getSortTimestamp(a.sortDate || a.startDate)
        if (bTime !== aTime) {
          return bTime - aTime
        }
        return String(a.title).localeCompare(String(b.title))
      })
    }
  }
}
</script>
